import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL?.trim() || "http://localhost:5050"}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,

  (error) => {
    if (
      error.response?.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("user");

      window.location.assign("/login");
    }

    return Promise.reject(error);
  },
);

export default api;
